/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { Container, Divider, H5, Stack, Text } from "@carrotfertility/carotene"
import { ArrowLink } from "../../../../components/views/atoms/links/ArrowLink"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"

const title = defineMessage({
  defaultMessage: "Looking for something else?"
})
const shortMessage = defineMessage({
  defaultMessage: "Consult your employer to learn how they support some types of providers outside of Carrot."
})
const longMessage = defineMessage({
  defaultMessage:
    "Consult your employer's HR team or benefits portal to learn how they support some types of providers outside of Carrot."
})
const longMessageWhenAdditionalEmployerBenefits = defineMessage({
  defaultMessage: "Your employer supports some types of providers outside of Carrot."
})

export function FertilityWraparoundMessageForDropdown(): JSX.Element {
  const intl = useIntl()

  return (
    <>
      <Divider paddingLeftRight="medium" />
      <Container padding="medium">
        <Stack spacing="none">
          <H5 variant="primary">{intl.formatMessage(title)}</H5>
          <Text font="gotham" size="small">
            {intl.formatMessage(shortMessage)}
          </Text>
        </Stack>
      </Container>
    </>
  )
}

export function FertilityWraparoundMessageForSidebar(): JSX.Element {
  const intl = useIntl()

  return (
    <Container background="white" borderRadius="8px" padding="medium">
      <Stack spacing="tiny">
        <Text font="gotham" weight="bold">
          {intl.formatMessage(title)}
        </Text>
        <Text font="gotham" size="small">
          {intl.formatMessage(longMessage)}
        </Text>
      </Stack>
    </Container>
  )
}

export function FertilityWraparoundMessageWhenAdditionalEmployerBenefitsForSidebar(): JSX.Element {
  const intl = useIntl()

  return (
    <Container background="white" borderRadius="8px" padding="medium">
      <Stack spacing="tiny">
        <Text font="gotham" weight="bold">
          {intl.formatMessage(title)}
        </Text>
        <Text font="gotham" size="small">
          {intl.formatMessage(longMessageWhenAdditionalEmployerBenefits)}
        </Text>
        <ArrowLink to="/your-benefit-guide/coverage/additional-employer-benefits">
          <FormattedMessage defaultMessage={`Learn more about those offerings`} />
        </ArrowLink>
      </Stack>
    </Container>
  )
}
